(function ($) {
  function loadPickupAvailability(variantId) {
    if (!variantId) return;

    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = routesRoot + 'variants/' + variantId + '/?section_id=pickup-availability';

    $.get(url, function (responseText) {
      $('#shopify-section-pickup-availability').remove();
      $('body').append(responseText);
    }).fail(function (err) {
      console.error('Pickup availability fetch failed', err);
    });
  }

  function openModal() {
    $('#PickupAvailabilityModal').attr('aria-hidden', 'false').addClass('is-open');
    $('body').addClass('pickup-modal-open');
  }

  function closeModal() {
    $('#PickupAvailabilityModal').attr('aria-hidden', 'true').removeClass('is-open');
    $('body').removeClass('pickup-modal-open');
  }

  $(document).on('click', '[data-pickup-availability-modal-open]', function (e) {
    e.preventDefault();
    openModal();
  });

  $(document).on('click', '[data-pickup-modal-close]', function (e) {
    e.preventDefault();
    closeModal();
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  $(document).ready(function () {
    var $variantSelect = $('[data-pickup-variant-select]');
    var initialVariantId = $variantSelect.val() || $variantSelect.data('initial-variant-id');

    loadPickupAvailability(initialVariantId);

    $variantSelect.on('change', function () {
      loadPickupAvailability($(this).val());
    });
  });
})(jQuery);